import React from 'react';
import styled from 'styled-components';
import { IconName } from 'affiny-ui/src/components/icon';
import rem from '../../utils/rem';
import { Box, Flex, Text } from '../primitives';
import { Icon } from '../icon';

type Props = {
  icon: IconName;
  image: string;
  label: string;
  answer?: string;
  onClick?: () => void;
};

export const Yearning = ({ icon, image, label, answer, onClick }: Props) => {
  return (
    <Box
      bg="light"
      borderRadius={['8px', 'small']}
      boxShadow={['shadowWebValue', 'box']}
      onClick={onClick}
    >
      <Box
        height={['100px', rem(133)]}
        backgroundImage={`url(${image})`}
        backgroundSize="cover"
        backgroundPosition="center center"
        borderTopLeftRadius={['8px', 'small']}
        borderTopRightRadius={['8px', 'small']}
      />
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height={['85px', rem(115)]}
      >
        <Flex
          position="absolute"
          left="50%"
          top={0}
          transform="translate(-50%, -50%)"
          bg="light"
          borderRadius="50%"
          alignItems="center"
          justifyContent="center"
          size={['46px', rem(72)]}
        >
          <Icon name={icon} color={['accent', 'accent']} size={[30, 32]} />
        </Flex>
        <Text
          mb={['xSmall', 'small']}
          mt={['small', '0px']}
          color={['secondary', 'secondary'] as any}
          fontSize={['size16', 'size14']}
          whiteSpace="nowrap"
        >
          {label}
        </Text>
        {answer && (
          <SAnswer
            color={['primary', 'primary'] as any}
            fontSize={['size18', 'size24']}
            whiteSpace="nowrap"
            fontWeight={['normal', 600]}
          >
            {answer}
          </SAnswer>
        )}
      </Flex>
    </Box>
  );
};

const SAnswer = styled(Text)`
  &::first-letter {
    text-transform: uppercase;
  }
`;
